export default "__VITE_ASSET__0ZVkGOoO__"